import React from 'react';
import PropTypes from 'prop-types';
import BasicComment from './BasicComment';

const Reply = ({ reply, loggedInUser, toggleLike, deleteReply, reportReply, toggleReply }) => (
  reply.deleted === false &&
    <BasicComment
      userAccess={loggedInUser.computed_access}
      comment={reply}
      onLikeClick={toggleLike}
      onDeleteClick={deleteReply}
      onReportClick={reportReply}
      onReplyClick={toggleReply}
    />
);

Reply.propTypes = {
  reply: PropTypes.object.isRequired,
  loggedInUser: PropTypes.object.isRequired,
  toggleLike: PropTypes.func,
  deleteReply: PropTypes.func,
  reportReply: PropTypes.func,
  toggleReply: PropTypes.func,
};

export default Reply;



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/Reply.js